/**
 * Utility to extract JSON data from global Backbone collections or models.
 * Used to pass data from the WiseMetering namespace into React components.
 */

// Helper to change camelCase keys to snake_case for backend compatibility
const toSnakeCase = (str) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

const mapToBackend = (data) => {
    return Object.keys(data).reduce((acc, key) => {
        acc[toSnakeCase(key)] = data[key];
        return acc;
    }, {});
};

export const getBackboneData = (collection, id = null, filter = null) => {
    if (id !== null) {
        const model = WiseMetering?.[collection]?.get(id);
        return model ? model.toJSON() : null;
    } else if (filter !== null) {
        return WiseMetering?.[collection]?.where(filter).map(model => model.toJSON());
    } else {
        return WiseMetering?.[collection]?.toJSON();
    }
};

export const getCurrentPath = () => {
    return window.Backbone?.history?.getFragment() || '';
};

export const navigate = (href, options = { trigger: true }) => {
    window.Backbone?.history?.navigate(href, options);
};

export const setBackboneData = (collectionName, data) => {
    const payload = mapToBackend(data);

    let model = payload.id ? WiseMetering[collectionName].get(payload.id) : new (WiseMetering[collectionName].model)();

    if (!model) {
        return Promise.reject(new Error(`Target ${collectionName} or Model ${payload.id} not found.`));
    }

    const isNew = model.isNew();

    let attributesToSave = isNew ? payload : model.changedAttributes(payload);

    if (!attributesToSave) {
        return Promise.reject(new Error(`No changes detected for ${collectionName} with ID ${payload.id}. Skipping save.`));
    }

    return new Promise((resolve, reject) => {
        model.save(attributesToSave, { wait: true, patch: !isNew })
            .done((response) => {
                if (isNew) {
                    WiseMetering?.[collectionName]?.add(model);
                }
                resolve(response);
            })
            .fail((err) => reject(err));
    });
};
